<div>
    <div class="flex items-center justify-center dialog-header">
        Delete Department
        <div class="absolute right-4">
            <button (click)="handleCloseDialog()" class="text-white hover:text-gray-300">
                <i class="pi pi-times"></i>
            </button>
        </div>
    </div>

   <div class="dialog-content p-6 text-center">
    <!-- Trash Icon -->
    <i class="pi pi-trash text-gray-600 mb-4" style="font-size: 27px;"></i>

    <!-- Title -->
    <div class="font-semibold text-xl mb-2">
        Are you sure you want to delete this department?
    </div>

    <!-- Course Info -->
    <div class="text-gray-600">
        Deoartment Name - <span class="font-medium">{{ departmentData?.name }}</span>
    </div>

    <!-- Warning -->
    <div class="text-red-500 mt-2">
        This action cannot be undone.
    </div>

    <!-- Buttons -->
    <div class="flex gap-4 mt-7 justify-center">
        <p-button 
            label="Cancel" 
            severity="danger" 
            variant="outlined" 
            (click)="handleCloseDialog()">
        </p-button>

        <p-button 
            label="Delete" 
            icon="pi pi-trash" 
            (click)="handleDelete()" 
            [disabled]="btnLoading"
            [loading]="btnLoading">
        </p-button>
    </div>
</div>

</div>